<script lang="ts" setup></script>

<template>
  <footer class="bottom-0 mt-auto border-t border-green-900 bg-black">
    <slot />
  </footer>
</template>

<style scoped></style>
